"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
const polished_1 = require("polished");
const react_router_dom_1 = require("react-router-dom");
exports.Container = styled_components_1.default(react_router_dom_1.Link) `
  display: flex;
  flex-direction: row;
  padding: 5px 15px;
  text-decoration: none;

  color: #7c7e80;
  font-weight: 400;
  font-size: ${props => props.theme.sizes.navMenuItem};

  &:hover {
    color: ${props => props.theme.colors.primary};
    text-decoration: none;
    cursor: pointer;
  }
`;
exports.Title = styled_components_1.default.div `
  display: flex;
  flex: 1;
  align-items: center;
`;
exports.Icon = styled_components_1.default.div `
  display: flex;
  padding: 7px;
  border-radius: 3px;

  background: ${props => polished_1.darken(0.03, props.theme.backgrounds.nav)};
  margin-right: ${props => props.position === 'left' ? '10px' : 0};
`;
